export default {
  namespaced: true,
  state: {
    modalData: false
  },
  getters: {
    getModalData: (state) => {
      return state.modalData
    }
  },
  actions: {
    setModalData ({commit}, data) {
      commit('setModalData', false)
      commit('setModalData', data)
    },
    openModal ({commit, dispatch}, data) {
      if (data.data !== undefined) {
        dispatch('setModalData', data.data)
      }
      document.querySelector('.modal-backdrop').classList.add('modal-backdrop--show')
      document.querySelector('#' + data.id).classList.add('modal--show')
    },
    closeModal ({commit, dispatch}, data) {
      document.querySelector('.modal-backdrop').classList.remove('modal-backdrop--show')
      document.querySelector('#' + data.id).classList.remove('modal--show')
      dispatch('setModalData', '')
    }
  },
  mutations: {
    setModalData (state, data) {
      state.modalData = data
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/modal.js